export default "__VITE_ASSET__hSwTP0JZ__"